<template>
  <div class="content-center">
    <div class="banner">
      <div class="title">供应链服务</div>
      <div class="sub-title">打造门店全链路商品解决方案，提供行业供应链能力</div>
      <div
        class="btn"
        @click="openModal"
      >业务咨询</div>
    </div>
    <div class="businessLayout">
      <div class="sk-block-title">
        <div class="title">汇通达商业布局</div>
      </div>
      <div class="content">
        <img src="@/assets/images/industry/supplychain_layout.png" alt="">
      </div>
    </div>
    <div class="atlas">
      <div class="sk-block-title">
        <div class="title">上游供应链部分合作品牌图谱</div>
      </div>
      <div class="content">
        <img src="@/assets/images/industry/supplychain_atlas.png" alt="">
      </div>
    </div>
    <div class="salesChannel">
      <div class="sk-block-title">
        <div class="title">三大销售通路 商品直达会员店</div>
      </div>
      <div class="content">
        <img src="@/assets/images/industry/supplychain_salesChannel.png" alt="">
      </div>
    </div>
    <div class="specialSession">
      <div class="sk-block-title">
        <div class="title">品牌专场活动 商品营销活动 赋能商品</div>
      </div>
      <div class="content">
        <img src="@/assets/images/industry/supplychain_specialSession.png" alt="">
      </div>
    </div>
    <div class="shoppingFestival">
      <div class="sk-block-title">
        <div class="title">平台418全国乡镇购物节</div>
        <div class="sub-title">8类线上活动、o2o活动500+场，参与会员店7万家</div>
      </div>
      <div class="content">
        <img src="@/assets/images/industry/supplychain_shoppingFestival.png" alt="">
      </div>
    </div>
    <div class="category">
      <div class="sk-block-title">
        <div class="title">招商类目</div>
      </div>
      <div class="content">
        <img src="@/assets/images/industry/supplychain_category.png" alt="">
      </div>
    </div>
    <div class="rights">
      <div class="sk-block-title">
        <div class="title">四大权益 共创共赢</div>
      </div>
      <div class="content">
        <img src="@/assets/images/industry/supplychain_rights.png" alt="">
      </div>
    </div>
    <CarouselItem title="供应链服务" />
    <ConsultForm info-sources="供应链服务" />
    <TryModal v-if="visible" :visible="visible" info-sources="供应链服务" @cancel="modalClose" />
  </div>

</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import ConsultForm from '@/components/ConsultForm'
import TryModal from '@/components/TryModal'
import CarouselItem from '@/components/CarouselItem'

export default {
  metaInfo: metaInfo.Supplychain,
  components: {
    ConsultForm,
    TryModal,
    CarouselItem
  },
  data() {
    return {
      visible: false
    }
  },
  mounted() {

  },
  methods: {

    openModal: function() {
      this.visible = true
    },
    modalClose: function(data) {
      this.visible = data
    }
  }
}
</script>

<style lang="less" scoped>
.banner {
  background: url("~@/assets/images/industry/supplychain_banner.png") no-repeat center;
  padding: 95px 0 93px;
    .title {
      font-size: 48px;
      color: #FFFFFF;
      line-height: 55px;
    }
    .sub-title {
      font-size: 20px;
      color: #FFFFFF;
      margin-top: 31px;
    }
    .btn {
      width: 200px;
      height: 58px;
      line-height: 58px;
      background: #5742EB;
      color: #fff;
      border-radius: 6px;
      font-size: 22px;
      margin: 69px auto 0;
    }
}

.businessLayout {
  padding-bottom: 60px;
  .content {
    margin: 53px auto 0;
  }
}
.atlas {
  background: #fafafa;
  padding-bottom: 60px;
  .content {
    width: 1200px;
    margin: 50px auto 0;
  }
}

.salesChannel {
  .content {
    img {
      display: block;
      width: 940px;
      margin: 60px auto 0;
    }
  }
}

.specialSession {
  background: #fafafa;
  padding-bottom: 21px;
  .content {
    width: 853px;
    margin: 40px auto 0;
  }
}

.shoppingFestival {
  padding-bottom: 63px;
  .content {
    width: 1068px;
    margin: 50px auto 0;
    img {
      display: block;
      width: 1048px;
      height: 488px;
    }
  }
}

.category {
  background: #fafafa;
  padding-bottom: 91px;
  .content {
    width: 1181px;
    margin: 52px auto 0;
  }
}

.rights {
  background: #fff;
  padding-bottom: 55px;
  .content {
    width: 1212px;
    margin: 59px auto 0;
  }
}
</style>
